import { CSSProperties, ElementType, ReactNode } from 'react';

export type CardPadding = 'none' | 'sm' | 'md' | 'lg';
export type CardAs = 'div' | 'section' | 'article' | 'aside';

const PADDING_CLASS: Record<CardPadding, string> = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8'
};

export type CardProps = {
  as?: CardAs;
  header?: ReactNode;
  footer?: ReactNode;
  padding?: CardPadding;
  interactive?: boolean;
  className?: string;
  bodyClassName?: string;
  style?: CSSProperties;
  children?: ReactNode;
  onClick?: React.MouseEventHandler<HTMLElement>;
  'aria-label'?: string;
  id?: string;
};

export function Card({
  as = 'div',
  header,
  footer,
  padding = 'md',
  interactive = false,
  className = '',
  bodyClassName = '',
  style,
  children,
  onClick,
  ...rest
}: CardProps) {
  const Tag = as as ElementType;

  const baseClasses = [
    'rounded-2xl shadow-card bg-app-soft border border-hairline overflow-hidden',
    interactive
      ? 'cursor-pointer hover:shadow-card-hover transition-shadow duration-200'
      : '',
    className
  ]
    .filter(Boolean)
    .join(' ');

  const bodyClasses = [PADDING_CLASS[padding], bodyClassName]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag className={baseClasses} style={style} onClick={onClick} {...rest}>
      {header && (
        <div className="px-6 py-4 border-b border-hairline">{header}</div>
      )}

      {padding === 'none' && !bodyClassName ? (
        children
      ) : (
        <div className={bodyClasses}>{children}</div>
      )}

      {footer && (
        <div className="px-6 py-4 border-t border-hairline">{footer}</div>
      )}
    </Tag>
  );
}
